import { CompanyAssets } from "./equipment/CompanyAssets";

export const CompanyAssetsTab = () => {
  return <CompanyAssets />;
};